import React, { useEffect } from 'react'
import {  useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { DataGetAction } from 'redux/actions/http';
import IntlMessages from "util/IntlMessages"
import { Row, Col, Checkbox, Spin } from 'antd'
import moment from 'moment'
import Widget from 'components/Widget'
const Index = () => {
    const params = useParams()
    const dispatch = useDispatch()
    const { guid } = params
    console.log('=======guid', guid)

    const fetchPatientReport = () => {
        dispatch(DataGetAction('getPatientReport', { guid: guid }, 'gettingReportList'));

    }
    useEffect(fetchPatientReport, [guid])


    const reportProps = useSelector(state => state.report)

    const { patientReportData, spinner } = reportProps


    const { patientName, age, sex, email, phoneNumber, dailyUpdate, dailyBaseLine, redFlags } = patientReportData || {}
    console.log('====spinner===========', spinner)

    let styles = {
        label: {
            fontSize: '13px',
            color: '#989898'
        },
        longBtnLeftGrey: {
            fontSize: '13px',
            background: '#989898',
            border: '1px solid #989898',
            padding: '7px 5px',
            color: "white",
            textTransform: 'capitalize',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        longBtnRightGrey: {
            fontSize: '13px',
            color: '#989898',
            border: '1px solid #989898',
            padding: '7px 40px 7px 10px',
            textTransform: 'capitalize',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            whiteSpace: 'normal'
        },
        longBtnLeftBlue: {
            fontSize: '13px',
            background: '#0D7DD9',
            border: '1px solid #0D7DD9',
            padding: '7px 5px',
            color: "white",
            textTransform: 'capitalize',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
           
        },
        longBtnRightBlue: {
            fontSize: '13px',
            color: '#0D7DD9',
            border: '1px solid #0D7DD9',
            
            textTransform: 'capitalize',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            whiteSpace: 'normal'
        }
    }

    const renderTitle = (title, selectedOptionLabel, baseLineOptionSelect) => {
        return <div >
            <h6 className="gx-blue-font gx-text-capitalize gx-mb-2">{title}</h6>
            <div className="gx-d-flex gx-flex-column gx-flex-md-row">
                <div className="gx-d-flex gx-mb-3 gx-mb-md-0 gx-mr-0 gx-mr-md-3">
                    <div style={styles.longBtnLeftGrey}>BaseLine:</div>
                    <div style={styles.longBtnRightGrey} className="gx-p-2"> {baseLineOptionSelect}</div>
                </div>

                <div className="gx-d-flex">
                    <div style={styles.longBtnLeftBlue}>Selected:</div>
                    <div style={styles.longBtnRightBlue} className="gx-p-2">{selectedOptionLabel}</div>
                </div>

            </div>
        </div>
    }

    const dailyUpdateSingleItem = (item, index) => {
        let selectedOption = item.questionOption[item.selected[0]];
        let dailyBaseLineQuestion = dailyBaseLine.filter(Item => Item.questionLabel === item.questionLabel);
        let selectedDailyOption = dailyBaseLineQuestion[0].questionOption[dailyBaseLineQuestion[0].selected[0]];
        return <Widget
            styleName="report-widget widget-padding"
            title={renderTitle(item.questionLabel, selectedOption.optionLabel, selectedDailyOption.optionLabel)}
        >
            <div dangerouslySetInnerHTML={{ __html: selectedOption.decisionTree }}></div>
        </Widget>
    }

    const renderDailyUpdates = () => {
        if (dailyUpdate && dailyUpdate.length) {
            return dailyUpdate.map((item, index) => {
                return dailyUpdateSingleItem(item, index)
            })
        }
    }

    const renderSingleCheckbox = (selectedOption, questionOption) => {
        if (selectedOption && selectedOption.length) {
            return selectedOption.map((item) => {
                return <Checkbox value={item} checked={true} disabled><span className="gx-text-black">{questionOption[item].optionLabel}</span> </Checkbox>
            })
        }
    }

    const redFlagsSingleItem = (item) => {
        return <Widget
            styleName="report-widget red-flag-container"
            title={<h6 className="gx-blue-font gx-text-capitalize" style={{whiteSpace : 'normal'}}>{item.questionLabel}</h6>}
        >
            <Checkbox.Group defaultValue={item.selected} >
                {renderSingleCheckbox(item.selected, item.questionOption)}
            </Checkbox.Group>
        </Widget>
    }

    const renderRedFlags = () => {
        if (redFlags && redFlags.length) {
            return redFlags.map((item) => {
                return redFlagsSingleItem(item)
            })
        }
    }

    const renderRedFlagCount = () => {


        let count = 0;
        if (redFlags && redFlags.length > 0) {
            redFlags.forEach(Item => {
                console.log("============= Item.selected.length", Item.selected);
                let selected = (Item.selected && Item.selected.length) || 0;
                count = count + selected
            })
        }

        if (dailyBaseLine && dailyBaseLine.length > 0) {
            dailyBaseLine.forEach((Item, index) => {
                if (Item.selected[0] !== dailyUpdate[index].selected[0]) {
                    count = count + 1
                }
            })
        }

        return count === '0' ? <span className="blue-flag">{count}</span> : <span className="red-flag">{count}</span>
    }

    const renderReport = () => {
        if (patientReportData) {
            return <Widget styleName="patient-report" title={<h4 className="gx-text-primary">Daily Report</h4>}> <Row className="gx-mb-0 gx-mb-md-4" >
                <Col xl={6} lg={6} md={12} sm={12} xs={12} className="gx-mb-2 gx-mb-md-0">
                    <div className="gx-d-flex gx-flex-column">
                        <span style={styles.label}><IntlMessages id="report.reportModal.name" /></span>
                        <span className="gx-blue-font">{patientName}</span>
                    </div>
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={12} className="gx-mb-2 gx-mb-md-0">
                    <div className="gx-d-flex gx-flex-column">
                        <span style={styles.label}><IntlMessages id="report.reportModal.sex" /></span>
                        <span className="gx-blue-font">{sex}</span>
                    </div>
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={12} className="gx-mb-2 gx-mb-md-0">
                    <div className="gx-d-flex gx-flex-column">
                        <span style={styles.label}><IntlMessages id="report.reportModal.age" /></span>
                        <span className="gx-blue-font">{age}</span>
                    </div>
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={12} className="gx-mb-2 gx-mb-md-0">
                    <div className="gx-d-flex gx-flex-column" >
                        <span style={styles.label}><IntlMessages id="report.reportModal.redFlags" /></span>
                        <span className="gx-blue-font">{renderRedFlagCount(patientReportData && patientReportData)}</span>
                    </div>
                </Col>
            </Row>
                <Row className="gx-mb-5">
                    <Col xl={6} lg={6} md={12} sm={24} xs={24} className="gx-mb-2 gx-mb-md-0">
                        <div className="gx-d-flex gx-flex-column">
                            <span style={styles.label}><IntlMessages id="report.reportModal.email" /></span>
                            <span className="gx-blue-font">{email}</span>
                        </div>
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                        <div className="gx-d-flex gx-flex-column">
                            <span style={styles.label}><IntlMessages id="report.reportModal.phone" /></span>
                            <span className="gx-blue-font">{phoneNumber}</span>
                        </div> </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                        <div className="gx-d-flex gx-flex-column">
                            <span style={styles.label}><IntlMessages id="report.reportModal.baseLineUpdate" /></span>
                            <span className="gx-blue-font">{moment().format('Do MMM YYYY')}</span>
                        </div></Col>

                </Row>

                <h4 className="gx-blue-font gx-mb-5">
                    <IntlMessages id="report.reportModal.dailyHealthChanges" />
                </h4>


                {renderDailyUpdates()}



                <h4 className="gx-red-font gx-mb-5">
                    <IntlMessages id="report.reportModal.redFlagsHeading" />
                </h4>
                {renderRedFlags()}
            </Widget>
        }
    }

    return (
        <div>

            {spinner ? <Spin size="large" /> : <>
                {renderReport()}
            </>
            }
        </div>
    )
}

export default Index
